import * as React from "react";
import {FunctionComponent, useEffect, useState} from "react";
import {Button, Divider, useTheme} from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import {useAppSelector} from "../../../../../Config/Hooks";
import InsertChartIcon from '@mui/icons-material/InsertChart';
import {Period, PeriodSelector} from "@atiautomacao/ati-ui-library";


interface Props {
    onPeriod?: any,
    onClick?: any
}

const periodInterval = {
    week: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6},
    month: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 30},
    year: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 11},
    general: {startTime: "00:00:00", endTime: "23:59:59", startInterval: 6}
}

export const HeaderMenu: FunctionComponent<Props> = ({ onClick, onPeriod}: Props) => {
    const isAuthenticated = useAppSelector((state: any) => state.authentication.isAuthenticated);
    const openMainMenu = useAppSelector((state: any) => state.layout.openMainMenu);
    const openSubMenu = useAppSelector((state: any) => state.layout.openSubMenu);

    const initialPeriod: Period = {
        groupBy: "week",
        fromDateTime: new Date(),
        toDateTime: new Date()
    };

    const [period, setPeriod] = useState<Period>(initialPeriod);

    const insertChart = () => {
        onClick()
    }

    useEffect(() => {
        if (onPeriod) {
            onPeriod(period);
        }
    }, [period, onPeriod]);

    const theme = useTheme();

    if (isAuthenticated ) return (
        <Toolbar
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    top: 32,
                    bottom: 24,
                }}
            >
                <>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <PeriodSelector
                            styleProps={{base: {display: "flex", flexDirection: "row", alignItems: "center"}}}
                            mode="hybrid"
                            hideDatetime={false}
                            hideGroup={false}
                            inputFormat={period.groupBy === "day" ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
                            periodInterval={periodInterval}
                            period={period}
                            onChange={setPeriod}
                            groupByOptions={["day", "week", "month", "year", "general"]}
                        />
                        <Button
                            variant="contained"
                            size={"small"}
                            color={"primary"}
                            endIcon={<InsertChartIcon fontSize="small"/>}
                            onClick={insertChart}
                            sx={{ marginLeft: 2, textTransform: 'capitalize' }}
                        >
                            Gerar Gráficos
                        </Button>
                    </div>
                </>
            </Toolbar>
    );

    return null;
}